<template>
  <div class="langListItem">
    <div class="search-box">
      <i class="iconfont icon-icon_search" :style="`color:${inputChoose ? '#2690E1' : '#BFBFBF'}`" />
      <div class="input-box">
        <input class="input" v-model="searchInput" @blur="inputBlur" @focus="inputFocus" type="search" @input="onSearchInput" :placeholder="$t('lang_search')"/>
      </div>
    </div>
    <div class="searchItem" v-if="searchInput.length > 0">
      <div class="notItem" v-if="searchList.length == 0">{{ $t("lang_noData") }}</div>
      <div class="item" :style="`color: ${currentLang == item.code ? '#2590E1' : '#595959'}`" v-for="item in searchList" @click="(()=>{onChooseLang(item.code)})">
        {{item.name}}
      </div>
    </div>
    <div class="listItem" v-if="searchInput.length == 0">
      <div style="display: flex; flex-direction: row ; flex-wrap: wrap;" v-if="token">
        <div class="common" >{{$t('lang_commonuse')}}</div>
        <div class="common-Item" v-for="item in filterCommonLangs" @click="(()=>{onLang(item.source_code,item.target_code)})">
          {{item.source_name ? item.source_name : $t("upload_auto_check_lang")}}-{{item.target_name}}
        </div>
      </div>
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;overflow-y: auto; margin-top: 10px">
        <div class="item" v-for="item in langs">
          <div :class="getLangsItemClass(item)" @click="(()=>{ type == 1 && item.lock ? onLock() : onChooseLang(item.code)})">{{item.name}}</div>
          <i class="iconfont icon-icon_vipc11" v-if="type == 1 && item.lock" style="color: #F6BE6B; font-size: 14px; margin-left: 4px;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import useUserStore from "@/store/modules/user";
import basicUserStore from "@/store/modules/basic";
import {storeToRefs} from "pinia";
const userStore = useUserStore();
const basicStore = basicUserStore();

let call = defineEmits(["onChooseLang", "onLockLang"])

const { token } = storeToRefs(userStore);

interface Props {
  langs: [],
  commonLangs: [],
  type: number,  // 0 源文语言 1 目标语言 
  currentLang: string,
}
const props = defineProps<Props>()

let searchInput = ref("")
let inputChoose = ref(false)
let searchList = ref([])

const getLangsItemClass = (item) => {
  if (props.type == 1) {
    if (item.lock) {
      return 'item-un-title'
    }
    return props.currentLang != item.code ? 'item-title' : 'item-select-title'
  }
  return props.currentLang != item.code ? 'item-title' : 'item-select-title'
}

const filterCommonLangs = computed(() => {
  if (props.commonLangs.length > 0) {
    return props.commonLangs
  }else {
    let commonList = []
    // let localCommonLangs = localStorage.getItem("commonlylangs")
    // if (localCommonLangs) {
    //   let langs = JSON.parse(localCommonLangs).split(",")
    //   let langMap = {}
    //   for (let i = 0; i < languages.value.length; i++) {
    //     let langItem = languages.value[i]
    //     langMap[langItem.code] = langItem
    //   }
    //   for (let i = 0; i < langs.length; i++) {
    //     let langsCode = langs[i]
    //     if (langMap[langsCode]) {
    //       commonList.push(langMap[langsCode])
    //     }
    //   }
    // }
    return commonList
  }
})

function onSearchInput() {
  if (searchInput.value.length > 0) {
    let list = props.langs.filter((item) => {
      if (item.name) {
        return item.name.toLowerCase().includes(searchInput.value.toLowerCase());
      }
      return false
    });
    searchList.value = list
  }else {
    searchList.value = []
  }
}

function inputBlur() {
  console.log("inputBlur")
  inputChoose.value = false
};

function inputFocus() {
  console.log("inputFocus")
  inputChoose.value = true
};

function onLang(sourceCode, targetCode) {
  call("onChooseLang", {sourceCode: sourceCode, targetCode: targetCode, isCommon: true})
}

function onChooseLang(code) {
  console.log("onChooseLang", code)
  if (props.type == 0) {
    call("onChooseLang", {sourceCode: code, targetCode: null, isCommon: false})
  }else {
    call("onChooseLang", {sourceCode: null, targetCode: code, isCommon: false})
  }
}

function onLock() {
  call("onLockLang")
}

function getRequestPDFLanguageList() {
  basicStore.getLanguages()
}

onMounted(()=>{
  console.log("init lang ===")
  getRequestPDFLanguageList()
})

</script>

<style lang="scss">
.langListItem {
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  .search-box {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #eee;
    height: 36px;
    margin-bottom: 10px;
    position: relative;
    align-items: center;
    .input-box {
      display: flex;
      left: 20px;
      position: absolute;
      right: 0;
      top: 8px;
      height: 20px;
      .input {
        flex: 1;
        border: none;
        font-size: 12px;
        border: 0;/*清除自带的2px的边框*/
        margin-left: 10px;
        outline: none;/*清除input点击之后的黑色边框*/
        background-color: transparent;
        color: var(--text-color);
      }
    }
  }
  .listItem {
    display: flex;
    height: 200px;
    width: 100%;
    margin-top: 10px;
    flex-direction: column;
    .common {
      display: flex;
      font-size: 12px;
      height: 17px;
      color: var(--text-color3);
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .common-Item {
      display: flex;
      font-size: 12px;
      height: 17px;
      color: var(--text-color1);
      margin-bottom: 10px;
      margin-right: 20px;
      cursor: pointer;
      font-weight: bold;
      &:hover {
        color: var(--progress-bg-color)
      }
    }
    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 180px;
      margin-bottom: 10px;
      .item-title { 
        cursor: pointer;
        font-size: 12px;
        height: 17px;
        color: var(--text-color1);
        &:hover {
          color: var(--progress-bg-color)
        }
      }
      .item-select-title { 
        cursor: pointer;
        font-size: 12px;
        height: 17px;
        color: var(--progress-bg-color);
      }
      .item-un-title { 
        cursor: pointer;
        font-size: 12px;
        height: 17px;
        color: #BFBFBF;
      }
    }
  }
  .searchItem {
    display: flex;
    flex-direction: column;
    padding: 5px 0;
    min-height: 100px;
    max-height: 200px;
    width: 100%;
    overflow-y: auto;
    .item {
      display: flex;
      width: 100%;
      cursor: pointer;
      font-size: 12px;
      height: 17px;
      color: var(--text-color3);
      margin-bottom: 10px;
      &:hover {
        color: var(--progress-bg-color)
      }
    }
    .notItem {
      display: flex;
      width: 100%;
      font-size: 12px;
      height: 17px;
      color: var(--text-color3);
      margin-bottom: 10px;
    }
  }
}

input::placeholder {
  color: #BFBFBF; /* 设置placeholder颜色为橙色 */
}

</style>
<style>
.langListItem input{
  font-size: 16px !important;
}
</style>